<template>
  <v-container fluid fill-height justify-center
      align-center>
      <v-flex xs12 lg8 xl5>
        <v-card class="elevation-1">
          <v-toolbar color="primary">
            <v-toolbar-title class="white--text">Admins</v-toolbar-title>
          </v-toolbar>
          <v-card-title>
            <v-flex xs12 sm12 md12 lg4>
              <v-text-field
                append-icon="search"
                label="Search"
                single-line
                hide-details
                v-model="search"
              ></v-text-field>
            </v-flex>
            <div class="d-flex align-center hidden-md-and-down" style="margin-left: auto">
              <v-card-actions @click="newAdmin()">
                <v-btn color="primary" dark>New Admin
                <v-icon dark right>add</v-icon>
                </v-btn>
              </v-card-actions>
          </div>
          <v-flex xs12 lg2 class="hidden-lg-and-up">
            <v-card-actions @click="newAdmin()">
                <v-btn color="primary" block dark>New Admin
                <v-icon dark right>add</v-icon>
                </v-btn>
              </v-card-actions>
          </v-flex>
          </v-card-title>
            <v-data-table
                :headers="headers"
                :items="items"
                :search="search"
                :loading="loading"
                hide-actions
              >
              <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item.id }}</td>
                <td class="text-xs-center">{{ props.item.first_name }} {{ props.item.last_name }}</td>
                <td class="text-xs-center">{{ props.item.email }}</td>
                <td class="text-xs-center">
                  <v-layout align-center>
                    <v-flex>
                      <v-btn 
                        @click="editItem(props.item)" 
                        small 
                        dark
                        >edit
                        </v-btn>
                    </v-flex>
                  </v-layout>
                </td>
                <td class="text-xs-left">
                  <v-layout align-center>
                    <v-flex>
                      <v-dialog v-model="dialog" persistent max-width="290">
                        <v-btn 
                        slot="activator"
                        flat 
                        icon 
                        color="red"
                        @click="userId(props.item.id)"
                        >
                        <v-icon>delete</v-icon>
                      </v-btn>
                        <v-card>
                          <v-card-title class="headline">Confirm your action</v-card-title>
                          <v-card-text>Are you sure you want to delete this admin?<br>This action can not be reverted</v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary"  @click.native="closeDialog()">Disagree</v-btn>
                            <v-btn color="red" dark  @click.native="closeDialog(); deleteItem(id)">Delete</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-flex>
                  </v-layout>
                </td>
              </template>
            </v-data-table>
        </v-card>
      </v-flex>
    <div class="alert">
      <v-alert
        color="success"
        icon="check_circle"
        :value="alert"
        transition="scale-transition"
      >
        You have successfully deleted an account.
      </v-alert>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      search: "",
      loading: true,
      headers: [
        { text: "ID", value: "id", sortable: false, align: "center" },
        { text: "Name", value: "name", sortable: false, align: "center" },
        { text: "Email", value: "email", sortable: false, align: "center" }
      ],
      items: [],
      alert: false,
      dialog: false,
      id: ''
    };
  },
  methods: {
    getAdmins() {
      axios.get("/admins").then(response => {
        this.items = response.data.users;
        this.loading = false;
      });
    },
    closeDialog() {
      this.dialog = !this.dialog;
    },
    alerting() {
      this.alert = !this.alert;
      setTimeout(() => {
        this.alert = !this.alert;
      }, 2500);
    },
    newAdmin() {
      this.$router.push("/admin/admins/new");
    },
    userId(id) {
      this.id = id;
    },
    editItem(item) {
      this.$router.push({ path: `/admin/admins/edit/${item.id}` });
    },
    deleteItem(id) {
      axios.delete("/users/" + id).then(response => {
        this.alerting();
        this.getAdmins();
      });
    }
  },
  created() {
    this.getAdmins();
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/Admins/Admins.vue